export enum LmsConnectionColumnId {
  Lms = "lmsName",
  DeploymentId = "deploymentId",
  FirstLaunchAt = "firstLaunchAt",
  LastLaunchAt = "lastLaunchAt",
  UsersCount = "usersCount",
}

interface LmsConnectionColumn {
  id: LmsConnectionColumnId;
  label: string;
}

export const LMS_CONNECTION_COLUMNS: readonly LmsConnectionColumn[] = [
  { id: LmsConnectionColumnId.Lms, label: "LMS" },
  { id: LmsConnectionColumnId.DeploymentId, label: "Deployment ID" },
  { id: LmsConnectionColumnId.FirstLaunchAt, label: "Дата першого входу" },
  { id: LmsConnectionColumnId.LastLaunchAt, label: "Дата останнього входу" },
  { id: LmsConnectionColumnId.UsersCount, label: "Кількість користувачів" },
];

export const LMS_CONNECTIONS_EMPTY = "Школа ще не підключала LMS";
export const LMS_CONNECTIONS_ERROR = "Не вдалося завантажити LMS інтеграції";
